import { useState } from "react";

const terpColors = {
  Limonene: "text-yellow-400",
  Myrcene: "text-purple-400",
  Caryophyllene: "text-red-400",
  Pinene: "text-green-400",
  Linalool: "text-pink-400",
  Humulene: "text-orange-400",
  Terpinolene: "text-blue-400",
  Ocimene: "text-cyan-400",
  Bisabolol: "text-rose-300"
};

export default function Terpenes() {
  const [search, setSearch] = useState("");
  const [openTerp, setOpenTerp] = useState(null);

  const terpeneProfiles = {
    Limonene: {
  vibe: "Uplifting",
  description: "A citrus-forward terpene known for boosting mood and reducing stress.",
  effects: ["uplifting", "anti-anxiety", "mood boost"],
  mental: "Promotes positivity and reduces stress.",
  physical: "Light body relaxation without sedation.",

  therapeutic: ["anti-anxiety", "antidepressant", "anti-inflammatory", "antifungal"],

  strains: ["Super Lemon Haze", "Sour Diesel", "OG Kush"],

  aroma: "Citrus, lemon, orange zest",

  funFact: "Commonly found in citrus peels, limonene is used in cleaning products due to its antibacterial properties.",

  use: "Best for daytime, stress relief, and mood support.",
  thc: "Reduces THC-induced anxiety while enhancing euphoria.",
  feel: "Happy, clear-headed, energized."
},

  Myrcene: {
  vibe: "Sedating",
  description: "The most common cannabis terpene, responsible for deep relaxation.",
  effects: ["sedating", "muscle relaxation", "sleep support"],
  mental: "Calms racing thoughts and reduces stimulation.",
  physical: "Heavy body effect, often leading to couch-lock.",

  therapeutic: ["sedative", "muscle relaxant", "anti-inflammatory", "analgesic"],

  strains: ["Granddaddy Purple", "Blue Dream", "OG Kush"],

  aroma: "Earthy, musky, herbal, cloves",

  funFact: "High myrcene levels are often used to classify strains as 'indica-like' effects.",

  use: "Best for evening, sleep, and pain relief.",
  thc: "Amplifies THC absorption and intensity.",
  feel: "Heavy, slow, deeply relaxed."
},

Caryophyllene: {
  vibe: "Balanced",
  description: "A spicy terpene that directly interacts with the endocannabinoid system.",
  effects: ["pain relief", "anti-inflammatory", "stress reduction"],
  mental: "Grounding and stabilizing.",
  physical: "Targets inflammation and nerve pain.",

  therapeutic: ["anti-inflammatory", "analgesic", "antibacterial", "gastroprotective"],

  strains: ["Girl Scout Cookies", "Bubba Kush", "Chemdawg"],

  aroma: "Spicy, peppery, woody",

  funFact: "It’s the only terpene known to directly activate CB2 receptors like cannabinoids do.",

  use: "Chronic pain, inflammation, stress.",
  thc: "Balances THC effects.",
  feel: "Calm, steady, physically relieved."
},

Pinene: {
  vibe: "Focused",
  description: "A fresh terpene that promotes alertness and clarity.",
  effects: ["focus", "alertness", "memory support"],
  mental: "Improves clarity and reduces brain fog.",
  physical: "Opens airways and supports breathing.",

  therapeutic: ["bronchodilator", "anti-inflammatory", "antibacterial"],

  strains: ["Jack Herer", "Strawberry Cough", "Trainwreck"],

  aroma: "Pine, forest, fresh herbs",

  funFact: "Pinene is also found in pine needles and is used in traditional medicine for respiratory issues.",

  use: "Daytime productivity and focus.",
  thc: "May counteract THC memory impairment.",
  feel: "Sharp, alert, clear."
},

Linalool: {
  vibe: "Calming",
  description: "A floral terpene known for relaxation and anxiety relief.",
  effects: ["calming", "anti-anxiety", "sleep support"],
  mental: "Reduces anxiety and promotes calm.",
  physical: "Relaxes muscles and tension.",

  therapeutic: ["anxiolytic", "sedative", "anti-epileptic", "anti-inflammatory"],

  strains: ["Lavender", "LA Confidential", "Amnesia Haze"],

  aroma: "Floral, lavender, sweet",

  funFact: "Also found in lavender and used in aromatherapy for stress relief.",

  use: "Anxiety, PTSD, sleep.",
  thc: "Softens THC intensity.",
  feel: "Peaceful, calm, relaxed."
},

Humulene: {
  vibe: "Balanced",
  description: "A terpene known for reducing inflammation and appetite.",
  effects: ["anti-inflammatory", "appetite control"],
  mental: "Neutral and stabilizing.",
  physical: "Reduces swelling and inflammation.",

  therapeutic: ["anti-inflammatory", "antibacterial", "appetite suppressant"],

  strains: ["Girl Scout Cookies", "Headband", "White Widow"],

  aroma: "Earthy, woody, herbal",

  funFact: "Also found in hops (used in beer), giving it a slightly bitter profile.",

  use: "Inflammation and recovery.",
  thc: "May reduce munchies.",
  feel: "Clean, balanced."
},

Terpinolene: {
  vibe: "Energetic",
  description: "A stimulating terpene associated with creativity.",
  effects: ["energizing", "creative", "uplifting"],
  mental: "Boosts creativity and alertness.",
  physical: "Light body effect.",

  therapeutic: ["antioxidant", "antibacterial", "antifungal"],

  strains: ["Jack Herer", "Ghost Train Haze", "Dutch Treat"],

  aroma: "Fruity, herbal, piney",

  funFact: "One of the least common dominant terpenes in cannabis.",

  use: "Creativity and daytime use.",
  thc: "Amplifies cerebral effects.",
  feel: "Buzzy, energetic, creative."
},

Ocimene: {
  vibe: "Light",
  description: "A bright terpene linked to energy and freshness.",
  effects: ["energizing", "clear-headed"],
  mental: "Promotes alertness.",
  physical: "Minimal heaviness.",

  therapeutic: ["antiviral", "antifungal", "anti-inflammatory"],

  strains: ["Golden Goat", "Strawberry Cough"],

  aroma: "Sweet, herbal, citrus",

  funFact: "Often found in mint, parsley, and orchids.",

  use: "Fatigue and low energy.",
  thc: "Supports functional highs.",
  feel: "Light, airy, uplifting."
},

Bisabolol: {
  vibe: "Soothing",
  description: "A gentle terpene known for healing and calming effects.",
  effects: ["calming", "anti-inflammatory"],
  mental: "Reduces stress.",
  physical: "Supports healing and reduces irritation.",

  therapeutic: ["anti-inflammatory", "antimicrobial", "skin healing"],

  strains: ["Harle-Tsu", "ACDC"],

  aroma: "Floral, sweet, chamomile",

  funFact: "Widely used in skincare products for its soothing properties.",

  use: "Recovery and stress.",
  thc: "Smooths THC intensity.",
  feel: "Soft, calming, restorative."
}

    // 👉 add the rest of your terps here (same structure)
  };

  const filtered = Object.entries(terpeneProfiles).filter(([name]) =>
    name.toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (name) => {
    setOpenTerp(openTerp === name ? null : name);
  };

  return (
    <div className="bg-black text-white min-h-screen p-6 max-w-4xl mx-auto">

      {/* HEADER */}
      <h1 className="text-2xl font-bold text-center mb-2">
        🌿 Terpenes
      </h1>

      <p className="text-sm opacity-70 text-center mb-6">
        Learn how terpenes shape your experience.
      </p>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search terpenes..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full p-3 rounded-xl bg-white/10 border border-white/10 mb-6"
      />

      {/* CARDS */}
      <div className="space-y-3">
        {filtered.map(([name, terp]) => {
          const isOpen = openTerp === name;

          return (
            <div
              key={name}
              className="bg-white/10 rounded-2xl border border-white/10 overflow-hidden"
            >

              {/* HEADER (CLICKABLE) */}
              <button
                onClick={() => toggle(name)}
                className="w-full text-left p-4 flex justify-between items-center"
              >
                <div>
                  <h2 className={`font-semibold ${terpColors[name] || ""}`}>
                    {name} <span className="text-xs opacity-60">({terp.vibe})</span>
                  </h2>
                  <p className="text-sm opacity-70">
                    {terp.description}
                  </p>
                </div>

                <span className="text-xl">
                  {isOpen ? "−" : "+"}
                </span>
              </button>

              {/* EXPANDED CONTENT */}
              {isOpen && (
                <div className="p-4 pt-0 text-sm space-y-3">

                  {/* EFFECT TAGS */}
                  <div className="flex flex-wrap gap-2">
                    {terp.effects.map((e) => (
                      <span key={e} className="text-xs bg-white/10 px-2 py-1 rounded">
                        {e}
                      </span>
                    ))}
                  </div>

                  <p><strong>Mental:</strong> {terp.mental}</p>
                  <p><strong>Physical:</strong> {terp.physical}</p>

                  <p>
                    <strong>Therapeutic:</strong>{" "}
                    {terp.therapeutic.join(", ")}
                  </p>

                  <p>
                    <strong>Common In:</strong>{" "}
                    {terp.strains.join(", ")}
                  </p>

                  <p><strong>Aroma:</strong> {terp.aroma}</p>

                  <p className="italic opacity-70">
                    💡 {terp.funFact}
                  </p>

                  <p><strong>Best Use:</strong> {terp.use}</p>

                  <p className="opacity-80">
                    <strong>THC Interaction:</strong> {terp.thc}
                  </p>

                  <p className="opacity-70 italic">
                    Overall feel: {terp.feel}
                  </p>

                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}